import passwordIcon from "./passwordIcon.png";
import userIcon from "./userIcon.png";
import arrowLeft from "./arrowLeft.svg";
import arrowRight from "./arrowRight.svg";
import arrowDown from "./arrowDown.svg";
import availableCash from "./availableCash.svg";
import awaitingPayment from "./awaitingPayment.svg";
import calendar from "./calendar.svg";
import dashboardActive from "./dashboardActive.svg";
import notSubmitted from "./notSubmitted.svg";
import pettyCash from "./pettyCash.svg";
import reconciliation from "./reconciliation.svg";
import reports from "./reports.svg";
import vouchers from "./vouchers.svg";
import bellIcon from "./bellIcon.svg";
import backIcon from "./backIcon.svg";
import plusIcon from "./plusIcon.svg";
import searchIcon from "./searchIcon.svg";
import trashIcon from "./trashIcon.svg";
import circlePlusIcon from "./circlePlus.svg";
import loopIcon from "./loopIcon.svg";
import laptopIcon from "./laptopIcon.svg";
import mobileIcon from "./mobileIcon.svg";
import removeCircleIcon from "./removeCircleIcon.svg";
import faqIcon from "./faqIcon.svg";
import newIcon from "./newIcon.svg";
import sendMailIcon from "./sendMailIcon.svg";
import requestIcon from "./requestIcon.svg";
import helpIcon from "./helpIcon.svg";
import editPhotoIcon from "./editPhotoIcon.svg";
import helpIcon2 from "./helpIcon2.svg";
import assignIcon from "./assignIcon.svg";
import accountIcon from "./accountIcon.svg";
import signoutIcon from "./signoutIcon.svg";
import raiseIcon from "./raiseIcon.svg";
import calendarIcon from "./calendarIcon.svg";
import attachmentIcon from "./attachmentIcon.svg";
import editIcon from "./editIcon.svg";
import squareTickIcon from "./squareTick.svg";
import squareTimesIcon from "./squareTimes.svg";
import squareAttachmentIcon from "./squareAttachment.svg";
import squareEyeIcon from "./squareEye.svg";
import fullscreenIcon from "./fullscreen.svg";
import zoomInIcon from "./zoomIn.svg";
import zoomOutIcon from "./zoomOut.svg";
import editLightIcon from "./editLight.svg";
import trashLightIcon from "./trashLight.svg";
import downloadIcon from "./download-icon.svg";
import dashboardApproved from "./dashboardApproved.svg";
import dashboardRejected from "./dashboardRejected.svg";
import dashboardTender from "./dashboardTender.svg";
import openEye from "./ico-eye-open.svg"
import closeEye from "./ico-eye-close.svg"
import emailIcon from './emailIcon.svg'

export const icons = {
  passwordIcon,
  userIcon,
  arrowLeft,
  arrowRight,
  arrowDown,
  availableCash,
  awaitingPayment,
  calendar,
  dashboardActive,
  notSubmitted,
  pettyCash,
  reconciliation,
  reports,
  vouchers,
  backIcon,
  bellIcon,
  plusIcon,
  searchIcon,
  trashIcon,
  circlePlusIcon,
  loopIcon,
  laptopIcon,
  mobileIcon,
  removeCircleIcon,
  faqIcon,
  newIcon,
  sendMailIcon,
  requestIcon,
  helpIcon,
  editPhotoIcon,
  helpIcon2,
  assignIcon,
  accountIcon,
  signoutIcon,
  raiseIcon,
  calendarIcon,
  attachmentIcon,
  editIcon,
  squareTickIcon,
  squareTimesIcon,
  squareAttachmentIcon,
  squareEyeIcon,
  fullscreenIcon,
  zoomInIcon,
  zoomOutIcon,
  editLightIcon,
  trashLightIcon,
  downloadIcon,
  dashboardApproved,
  dashboardRejected,
  dashboardTender,
  openEye,
  closeEye,
  emailIcon,
};
